/* eslint-disable @typescript-eslint/naming-convention */

import React, {FC, useCallback} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import style from './style.module.scss';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {adaptive} from 'styles/mixins/Adaptive';
import {useEventsMediaState} from 'modules/events/mediaState/useEventsMediaState';
import {TASTING_IMAGES, TASTING_VIDEO_PLAYER} from 'modules/events/components/TastingMediaBanner/contstants';
import Icon from 'components/Icon';
import Picture from 'components/Picture';
import {SwiperOptions} from 'swiper/types';
import {Pagination} from 'swiper/modules';

const BREAKPOINTS = {
    0: {
        spaceBetween: 20,
    } as SwiperOptions,
    [adaptive.SIZE_XL_MIN]: {
        pagination: {
            enabled: true,
        },
        slidesPerGroup: 4,
        spaceBetween: 32,
    } as SwiperOptions,
};

const SWIPER_MODULES = [Pagination];
const SWIPER_PAGINATION = {
    clickable: true,
    enabled: false,
};

export const TastingSlider: FC = () => {
    const dispatch = useAppDispatch();
    const [_, setEventsMediaState] = useEventsMediaState();

    const onSliderItemClick = useCallback(
        (mediaSrc: string, mediaType: 'video' | 'image') => {
            dispatch(showModal(MODALS.DEGUSTATION_MEDIA_SLIDER.name));
            setEventsMediaState((state) => ({
                ...state,
                mediaSrc,
                mediaType,
            }));
        },
        [dispatch, setEventsMediaState],
    );

    return (
        <div className={style.main}>
            <Swiper
                breakpoints={BREAKPOINTS}
                modules={SWIPER_MODULES}
                pagination={SWIPER_PAGINATION}
                slidesPerView={'auto'}
            >
                {TASTING_IMAGES.map((src, idx) => {
                    const isVideo = 0 === idx;

                    return (
                        <SwiperSlide key={src}>
                            <div
                                className={style.sliderItem}
                                onClick={() =>
                                    onSliderItemClick(isVideo ? TASTING_VIDEO_PLAYER : src, isVideo ? 'video' : 'image')
                                }
                                role={'button'}
                            >
                                <Picture src={src} />
                                {isVideo && (
                                    <div className={style.videoBackdrop}>
                                        <Icon className={style.videoIcon} icon={'video-play'} />
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};
